import { useContext, useMemo, useEffect, useState } from 'react'
import { ConfigContext } from 'contexts/ConfigContext'
import objectPath from 'object-path'
import Select from 'react-select'
import { getCheckValue } from 'designer/component/action/Data'
import { DesignContext } from 'contexts/DesignContext'
import useAuth from 'hooks/useAuth'
import { checkLockMode } from '../action/Column'

const CustomUser = ({
  ui,
  rowData,
  onUpdateRowData,
  data,
  onUpdateData,
  fieldKey,
  fieldName,
  optionValue,
  column = {},
}) => {
  const designContext = useContext(DesignContext)
  const configContext = useContext(ConfigContext)
  const { employeeList = [] } = designContext
  const { layoutType } = configContext.state
  const { user } = useAuth()
  let value = data || objectPath.get(rowData, ui.field)
  const [selectValue, setSelectValue] = useState(null)
  let isLockEdit = checkLockMode(column, rowData)

  const colorByTheme = useMemo(
    () => (layoutType === 'dark' ? '#adb7be' : '#495057'),
    [],
  )

  const styles = {
    control: (base) => ({
      ...base,
      height: 35,
      minHeight: 35,
      backgroundColor: 'transparent',
    }),
    menu: (base) => ({
      ...base,
      zIndex: 2,
    }),
    singleValue: (base) => ({
      ...base,
      color: colorByTheme,
    }),
  }

  const compareValue = (option, value) => {
    let valueOption = objectPath.get(option, optionValue)
    return getCheckValue(valueOption) === getCheckValue(value)
  }

  const setValue = (value) => {
    return objectPath.get(value, optionValue)
  }

  const updateData = (option) => {
    let newValue = setValue(option)

    if (onUpdateData) {
      onUpdateData(newValue)
    } else if (onUpdateRowData) {
      objectPath.set(rowData, ui.field, newValue)
      onUpdateRowData(rowData)
    }
  }

  useEffect(() => {
    if (value === undefined) {
      value = objectPath.get(user, optionValue)
      updateData(user)
    }
    let selectValue = employeeList.find((option) => compareValue(option, value))
    setSelectValue(selectValue)
  }, [value])

  if (isLockEdit) {
    return <>{selectValue?.fullName}</>
  }

  return (
    <>
      <Select
        id={fieldKey}
        name={fieldName}
        isClearable
        className="w-100"
        value={selectValue}
        styles={styles}
        options={employeeList}
        getOptionLabel={(option) => option.fullName}
        getOptionValue={(option) => option[optionValue]}
        onChange={(option) => updateData(option)}
      />
    </>
  )
}

export default CustomUser
